import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-14ef1809")

_pushScopeId("data-v-14ef1809")
const _hoisted_1 = /*#__PURE__*/_createTextVNode("Filter")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Create invoice")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Delete")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Add Item")
const _hoisted_5 = { style: {"text-align":"right"} }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Create Invoice ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Cancel ")
const _hoisted_8 = {
  key: 1,
  class: "border p-3 mt-3 mb-3"
}
const _hoisted_9 = { class: "select-body" }
const _hoisted_10 = {
  key: 0,
  class: "select-column"
}
const _hoisted_11 = /*#__PURE__*/_createVNode("label", null, "Company Name", -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_13 = {
  key: 1,
  class: "select-column"
}
const _hoisted_14 = /*#__PURE__*/_createVNode("label", null, "Email Address", -1)
const _hoisted_15 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_16 = { class: "select-column" }
const _hoisted_17 = /*#__PURE__*/_createVNode("label", null, "Date Range", -1)
const _hoisted_18 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_19 = { class: "select-button-col" }
const _hoisted_20 = /*#__PURE__*/_createTextVNode("Search")
const _hoisted_21 = /*#__PURE__*/_createTextVNode("Clear")
const _hoisted_22 = {
  key: 0,
  class: "el-icon-loading"
}
const _hoisted_23 = { class: "desktop-content" }
const _hoisted_24 = { class: "pagination" }
const _hoisted_25 = { class: "mobile-content" }
const _hoisted_26 = { class: "pagination" }
const _hoisted_27 = /*#__PURE__*/_createVNode("span", null, "Only account owner has access to this section.", -1)
const _hoisted_28 = { class: "dialog-footer" }
const _hoisted_29 = /*#__PURE__*/_createTextVNode("Ok")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_input_number = _resolveComponent("el-input-number")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_dialog = _resolveComponent("el-dialog")
  const _component_el_date_picker = _resolveComponent("el-date-picker")
  const _component_InvoiceTablePage = _resolveComponent("InvoiceTablePage")
  const _component_el_pagination = _resolveComponent("el-pagination")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", null, [
      _createVNode(_component_el_button, {
        type: "primary",
        onClick: _ctx.toggleFilterMenu
      }, {
        default: _withId(() => [
          _hoisted_1
        ]),
        _: 1
      }, 8, ["onClick"]),
      (_ctx.isCustomInvoice)
        ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            type: "primary",
            onClick: _ctx.toggleInvoiceForm
          }, {
            default: _withId(() => [
              _hoisted_2
            ]),
            _: 1
          }, 8, ["onClick"]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.isCustomInvoice)
      ? (_openBlock(), _createBlock(_component_el_dialog, {
          key: 0,
          title: "Create Invoice",
          modelValue: _ctx.isShowInvoiceForm,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.isShowInvoiceForm = $event)),
          width: "1000px"
        }, {
          default: _withId(() => [
            _createVNode(_component_el_form, {
              ref: "invoiceFormRef",
              model: _ctx.invoiceForm,
              rules: _ctx.rules
            }, {
              default: _withId(() => [
                _createVNode(_component_el_form_item, {
                  label: "Customer Email",
                  "label-width": "150px",
                  prop: "account"
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _ctx.invoiceForm.account,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.invoiceForm.account = $event)),
                      filterable: "",
                      disabled: _ctx.invoiceForm._id
                    }, {
                      default: _withId(() => [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.companyData, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item._id,
                            label: item.name,
                            value: item._id
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue", "disabled"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { prop: "items" }, {
                  default: _withId(() => [
                    _createVNode(_component_el_table, {
                      data: _ctx.invoiceForm.items,
                      style: {"width":"100%"}
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_el_table_column, { label: "Name" }, {
                          default: _withId(({ row, $index }) => [
                            _createVNode(_component_el_form_item, {
                              prop: 'items.' + $index + '.name'
                            }, {
                              default: _withId(() => [
                                _createVNode(_component_el_input, {
                                  modelValue: row.name,
                                  "onUpdate:modelValue": ($event: any) => (row.name = $event)
                                }, null, 8, ["modelValue", "onUpdate:modelValue"])
                              ]),
                              _: 2
                            }, 1032, ["prop"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, { label: "Description" }, {
                          default: _withId(({ row, $index }) => [
                            _createVNode(_component_el_form_item, {
                              prop: 'items.' + $index + '.description'
                            }, {
                              default: _withId(() => [
                                _createVNode(_component_el_input, {
                                  modelValue: row.description,
                                  "onUpdate:modelValue": ($event: any) => (row.description = $event)
                                }, null, 8, ["modelValue", "onUpdate:modelValue"])
                              ]),
                              _: 2
                            }, 1032, ["prop"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, { label: "Quantity" }, {
                          default: _withId(({ row, $index }) => [
                            _createVNode(_component_el_form_item, {
                              prop: 'items.' + $index + '.quantity'
                            }, {
                              default: _withId(() => [
                                _createVNode(_component_el_input_number, {
                                  modelValue: row.quantity,
                                  "onUpdate:modelValue": ($event: any) => (row.quantity = $event),
                                  min: 1,
                                  step: 1,
                                  "step-strictly": "",
                                  "validate-event": "",
                                  "controls-position": "right"
                                }, null, 8, ["modelValue", "onUpdate:modelValue"])
                              ]),
                              _: 2
                            }, 1032, ["prop"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, { label: "Price" }, {
                          default: _withId(({ row, $index }) => [
                            _createVNode(_component_el_form_item, {
                              prop: 'items.' + $index + '.price'
                            }, {
                              default: _withId(() => [
                                _createVNode(_component_el_input_number, {
                                  modelValue: row.price,
                                  "onUpdate:modelValue": ($event: any) => (row.price = $event),
                                  min: 0,
                                  step: 1,
                                  "step-strictly": "",
                                  "validate-event": "",
                                  "controls-position": "right"
                                }, null, 8, ["modelValue", "onUpdate:modelValue"])
                              ]),
                              _: 2
                            }, 1032, ["prop"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, { label: "Action" }, {
                          default: _withId(({ row, $index }) => [
                            _createVNode(_component_el_button, {
                              size: "mini",
                              type: "danger",
                              onClick: ($event: any) => (_ctx.handleDeleteItem($index, row))
                            }, {
                              default: _withId(() => [
                                _hoisted_3
                              ]),
                              _: 2
                            }, 1032, ["onClick"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["data"]),
                    _createVNode(_component_el_button, {
                      type: "primary",
                      onClick: _ctx.addItem,
                      style: {"margin-top":"20px"}
                    }, {
                      default: _withId(() => [
                        _hoisted_4
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model", "rules"]),
            _createVNode("footer", _hoisted_5, [
              _createVNode(_component_el_button, {
                type: "primary",
                size: "small",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleCreateInvoice()))
              }, {
                default: _withId(() => [
                  _hoisted_6
                ]),
                _: 1
              }),
              _createVNode(_component_el_button, {
                size: "small",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.isShowInvoiceForm = false))
              }, {
                default: _withId(() => [
                  _hoisted_7
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : _createCommentVNode("", true),
    (_ctx.showFilterMenu)
      ? (_openBlock(), _createBlock("div", _hoisted_8, [
          _createVNode("div", _hoisted_9, [
            (_ctx.isSuperAdmin)
              ? (_openBlock(), _createBlock("div", _hoisted_10, [
                  _hoisted_11,
                  _hoisted_12,
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.selectedCompany,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.selectedCompany = $event)),
                    filterable: ""
                  }, {
                    default: _withId(() => [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.companyData, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item._id,
                          label: item.name,
                          value: item.name
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]))
              : _createCommentVNode("", true),
            (_ctx.isSuperAdmin)
              ? (_openBlock(), _createBlock("div", _hoisted_13, [
                  _hoisted_14,
                  _hoisted_15,
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.selectedEmail,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.selectedEmail = $event)),
                    filterable: ""
                  }, {
                    default: _withId(() => [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.companyData, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item._id,
                          label: item.owner && item.owner.email ? item.owner.email : 'N/A',
                          value: item.owner && item.owner._id ? item.owner._id : 'N/A'
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]))
              : _createCommentVNode("", true),
            _createVNode("div", _hoisted_16, [
              _hoisted_17,
              _hoisted_18,
              _createVNode(_component_el_date_picker, {
                modelValue: _ctx.daterange,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.daterange = $event)),
                type: "daterange",
                "range-separator": "To",
                "start-placeholder": "Start date",
                "end-placeholder": "End date"
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createVNode("div", _hoisted_19, [
            _createVNode("div", null, [
              _createVNode(_component_el_button, {
                type: "success",
                onClick: _ctx.filterInvoices
              }, {
                default: _withId(() => [
                  _hoisted_20
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _createVNode("div", null, [
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: _ctx.clearFilterMenu
              }, {
                default: _withId(() => [
                  _hoisted_21
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _createVNode("div", null, [
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: _ctx.exportInvoices,
                disabled: _ctx.isPendingExport || _ctx.totalRows == 0
              }, {
                default: _withId(() => [
                  (_ctx.isPendingExport)
                    ? (_openBlock(), _createBlock("i", _hoisted_22))
                    : _createCommentVNode("", true),
                  _createTextVNode(" Export CSV (" + _toDisplayString(_ctx.invoicesSelected.length ? _ctx.invoicesSelected.length : _ctx.totalRows) + ") ", 1)
                ]),
                _: 1
              }, 8, ["onClick", "disabled"])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_InvoiceTablePage, {
      listInvoices: _ctx.listInvoices,
      ListCards: _ctx.ListCards,
      onSeletedInvoices: _ctx.getMultipleSelection,
      key: _ctx.ListCards.length
    }, null, 8, ["listInvoices", "ListCards", "onSeletedInvoices"]),
    _createVNode("div", _hoisted_23, [
      _createVNode("div", _hoisted_24, [
        _createVNode(_component_el_pagination, {
          background: "",
          "page-sizes": [20, 50, 100],
          "page-size": _ctx.perPage,
          "current-page": _ctx.currentPage,
          layout: "total, prev, pager, next, sizes, jumper",
          total: _ctx.totalRows,
          onCurrentChange: _ctx.handleCurrentChange,
          onSizeChange: _ctx.handleSizeChange,
          onPrevClick: ($event: any) => (1)
        }, null, 8, ["page-size", "current-page", "total", "onCurrentChange", "onSizeChange"])
      ])
    ]),
    _createVNode("div", _hoisted_25, [
      _createVNode("div", _hoisted_26, [
        _createVNode(_component_el_pagination, {
          background: "",
          small: "",
          "page-sizes": [20, 50, 100],
          "page-size": _ctx.perPage,
          "current-page": _ctx.currentPage,
          layout: "pager, sizes",
          total: _ctx.totalRows,
          onCurrentChange: _ctx.handleCurrentChange,
          onSizeChange: _ctx.handleSizeChange,
          onPrevClick: ($event: any) => (1)
        }, null, 8, ["page-size", "current-page", "total", "onCurrentChange", "onSizeChange"])
      ])
    ]),
    _createVNode(_component_el_dialog, {
      title: "Warning",
      modelValue: _ctx.isShowWarning,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.isShowWarning = $event)),
      "before-close": _ctx.handleConfirm,
      width: "40%",
      center: ""
    }, {
      footer: _withId(() => [
        _createVNode("span", _hoisted_28, [
          _createVNode(_component_el_button, {
            type: "primary",
            size: "small",
            onClick: _ctx.handleConfirm
          }, {
            default: _withId(() => [
              _hoisted_29
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      default: _withId(() => [
        _hoisted_27
      ]),
      _: 1
    }, 8, ["modelValue", "before-close"])
  ], 64))
})